// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qEzq","toggle":"styles_toggle__1CxLk","preview":"styles_preview__92yh-"};